import ActionTypes from './ActionTypes';

const getAnalytics = payload => {
    return {
        type: ActionTypes.GET_ANALYTICS,
        payload,
    };
};

const getReviews = payload => {
    return {
        type: ActionTypes.GET_REVIEWS,
        payload,
    };
};


export { getAnalytics , getReviews };